import { createSlice, Dispatch, PayloadAction } from '@reduxjs/toolkit';
import { CoreApi } from '@inter-ikea-storageone/range';
import { RootState } from 'ducks';

export type RoomSizeHistory = {
  past: Array<{ x: number; y: number; z: number } | undefined>;
  present: { x: number; y: number; z: number } | undefined;
  future: Array<{ x: number; y: number; z: number } | undefined>;
};

export const initialState: RoomSizeHistory = {
  past: [],
  present: undefined,
  future: []
};

const roomSizeHistorySlice = createSlice({
  name: 'roomSizeHistory',
  initialState,
  reducers: {
    setPresentRoomSize(state, action: PayloadAction<{ x: number; y: number; z: number }>) {
      state.present = action.payload;
    },
    undo(state) {
      if (state.past.length === 0) {
        return state;
      }

      const previous = state.past[state.past.length - 1];
      const newPast = state.past.slice(0, state.past.length - 1);
      const newFuture = [state.present, ...state.future];

      state.past = newPast;
      state.present = previous;
      state.future = newFuture;
    }
  }
});

export const getPastRoomSizeHistory = (state: RootState) => state.roomSizeHistory.past;
export const getFutureRoomSizeHistory = (state: RootState) => state.roomSizeHistory.future;
export const undoRoomSize = (coreApi: CoreApi) => (
  dispatch: Dispatch<any>,
  getState: () => RootState
) => {
  dispatch(roomSizeHistorySlice.actions.undo());
  const state = getState();

  if (state.roomSizeHistory.present) {
    coreApi.kvadratRoom?.setRoomSize(
      state.roomSizeHistory.present.x,
      state.roomSizeHistory.present.y,
      state.roomSizeHistory.present.z
    );
  }
};

export const { setPresentRoomSize, undo } = roomSizeHistorySlice.actions;
export default roomSizeHistorySlice.reducer;
